import React, { Component } from "react";
import { Table, Tbody } from "react-super-responsive-table";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import THeadings from "../THeadings";
import { getArizonaDataJul2020 } from "../../../actions/arizonadataActions";
import TRowsAz from "../TRowsAz";

class TableJul2020Az extends Component {
  componentDidMount() {
    this.props.getArizonaDataJul2020();
  }
  render() {
    const { azjul2020 } = this.props;
    return (
      <>
        <h1>Arizona July 2020</h1>
        <Table>
          <THeadings />
          <Tbody>
            {azjul2020.map((data) => (
              <TRowsAz key={data._id} data={data} />
            ))}
          </Tbody>
        </Table>
      </>
    );
  }
}

TableJul2020Az.propTypes = {
  getArizonaDataJul2020: PropTypes.func.isRequired,
  azjul2020: PropTypes.array.isRequired,
};
const mapStateToProps = (state) => ({
  azjul2020: state.arizonadata.azjul2020,
});

export default connect(mapStateToProps, { getArizonaDataJul2020 })(
  TableJul2020Az
);
